import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { Circle } from '@mui/icons-material';
import { InfoIcon } from '../../../../icons';

export interface Props {
  label: string;
  hideIcon?: boolean;
  notFilled?: boolean;
  mode?: 'error' | 'info' | 'success' | 'warning';
  sx?: SxProps<Theme>;
  onClick?: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

export const StatusBadge: FC<Props> = ({
  mode = 'success',
  label,
  hideIcon = false,
  notFilled,
  sx,
  onClick,
  disabled,
  dataTestId
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        borderRadius: '24px',
        overflow: 'hidden',
        maxWidth: '100%',
        backgroundColor: !notFilled ? 'grey.50' : '',
        padding: '12px',
        '&:hover': {
          backgroundColor: 'grey.100'
        },
        ...sx,
        cursor: onClick ? 'pointer' : 'default',
        opacity: disabled ? '0.5' : '1',
        outlineWidth: '1px'
      }}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingRight: '4px',
          overflow: 'hidden'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
          <Circle
            sx={(theme) => ({
              display: 'inline-block',
              height: '20px',
              width: '10px',
              color: theme.palette[mode].main
            })}
          />
          <Typography
            color="primary.main"
            noWrap
            sx={{
              padding: '0 4px 0 8px',
              fontSize: '15px',
              lineHeight: '22px'
            }}
          >
            {label}
          </Typography>
        </Box>

        {!hideIcon && <InfoIcon width="18px" color="primary.main" />}
      </Box>

      <Box
        sx={{
          opacity: '0.1',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }}
      ></Box>
    </Box>
  );
};
